namespace JupitersChoice {
    export class CheckWinsCmd {

        @inject('EventManager') _eventManager: Sapphire.EventManager;
        @inject('GameServer') _gameServer: Sapphire.GameServer;
        @inject('BigWinModel') _bigWinModel: BigWinModel;
        @inject('BetModel') _betModel: Sapphire.BetModel;

        execute(): void {
            const response: any = this._gameServer.logicResponse;
            const hasWins = response.winnings.length > 0;

            if (!hasWins) {
                if(response.feature){
                    this._eventManager.publish('onCheckFeatureBigWin');
                }else{
                    this._eventManager.publish('onHasNoWins');
                }
            } else {
                this._eventManager.publish('onHasWins', [response]);
            }
        }
    }
}